export default {
  'memberWelcome.title': '欢迎使用会员卡！',
  'memberWelcome.description': '无论您身在何处，我们都会为您提供您喜爱的食物，以满足您的食物需求，点击下方图标添加会员卡。',
  'memberWelcome.wallet.loading': '正在加载钱包选项...',
  'memberWelcome.existing.title': '欢迎回来！',
  'memberWelcome.existing.content': '该手机号已注册。您可以继续使用您的会员权益！',
  'memberWelcome.existing.button': '知道了',
  'memberWelcome.viewCard': '查看会员卡',
  'memberWelcome.memberId': '会员 ID',
};
